export default __webpack_public_path__ + "static/media/bg-main.9366accc.png";